import news from "fragments/news/news"
import gql from "graphql-tag"

const GET_NEWS = gql`
  ${news}

  query getNews($id: ID!) {
    getNews(id: $id) {
      ...News
    }
  }
`

export default GET_NEWS
